import React, { useState, useCallback, Fragment } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { AppTheme, AppStyles } from '../styles/AppTheme';
import { Grid, FormControl, InputLabel, Select, MenuItem, Button, TextField, Input, Dialog, OutlinedInput, Chip } from '@material-ui/core';
import { AppButton } from '../common/components/AppButton';
import moment from 'moment';
import color from '@material-ui/core/colors/amber';
import { Helper } from '../common/helpers/Helper';
import { UiHelper } from '../common/helpers/UiHelper';
import { AppHelper } from '../helpers/AppHelper';
import { Fade, Slide } from '@material-ui/core';
import { Toast } from '../components/Toast';
import Autocomplete from '@material-ui/lab/Autocomplete';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

const quickDateRanges = [
  { key: '7_days', label: 'Last 7 days', amount: 7, unit: 'days' },
  { key: '30_days', label: 'Last 30 days', amount: 30, unit: 'days' },
  { key: '3_months', label: 'Last 3 months', amount: 3, unit: 'months' },
  { key: '6_months', label: 'Last 6 months', amount: 6, unit: 'months' },
];

const getQuickDateRange = (range) => {
  const today = moment();
  return {
    dateStart: today.clone().subtract(range.amount, range.unit).format('YYYY-MM-DD'),
    dateEnd: today.clone().subtract(1, 'day').format('YYYY-MM-DD'),
  };
};

const getMatchingQuickDateRange = (dateStart, dateEnd) => {
  const matchingRange = quickDateRanges.find((range) => {
    const dates = getQuickDateRange(range);
    return dates.dateStart === dateStart && dates.dateEnd === dateEnd;
  });
  return matchingRange ? matchingRange.key : 'custom';
};

export const AdPopFilterBar = ({ dateStart: initialDateStart, dateEnd: initialDateEnd, groupBy: initialGroupBy, groupByOptions, onFilter, buttonLabel, filterBy:initialFilterBy, filterByOptions = [], filterByValue: initialFilterByValue = '', inProcess = false, groupBySingleSelect = false, groupByFullWidth = false, allowEmptyGroupBy = false, showQuickDateRangePicker = false, dialogApplyInProcess, dialogErrorMessage, onCreateJob, dialogJobInProcess = false, createJobButtonLabel = 'Create a Job', onClearDialogError }) => {
  const defaultGroupBy = (groupByOptions[0] && groupByOptions[0].key) || 'DAY';
  const groupByGridSize = groupByFullWidth ? 12 : 6;
  const getSelectedOptions = (options, selectedValues) => {
    return options.filter((option) => selectedValues.includes(option.key));
  };
  const getFilterByHelperText = (filterKey) => {
    if (filterKey === 'CAMPAIGNS') return Helper.getString('sampleCampaignCode')
    if (filterKey === 'VENUES') return Helper.getString('sampleVenueCode')
    return '';
  };
  const getFilterByErrorText = (filterKey) => {
    if (!showMaxFilterByValueError[filterKey]) return '';
    if (filterKey === 'CAMPAIGNS') return Helper.getString('maxCampaignCode').replace('%n%', maxFilterByValue);
    if (filterKey === 'VENUES') return Helper.getString('maxVenueCode').replace('%n%', maxFilterByValue);
    return 'Maximum ' + maxFilterByValue + ' values allowed';
  };
  const renderMultiSelect = (name, label, options, selectedValues, placeholder) => (
    <Fragment>
      <InputLabel className={css(Styles.fieldLabel)}>{label}</InputLabel>
      <FormControl className={css(Styles.formControl)} margin='normal' fullWidth>
        <Autocomplete
          multiple
          disableCloseOnSelect
          options={options}
          value={getSelectedOptions(options, selectedValues)}
          getOptionLabel={(option) => option.value}
          classes={{
            inputRoot: css(Styles.autoCompleteInputRoot),
            tag: css(Styles.autoCompleteTag),
            popupIndicator: css(Styles.popupIndicator),
            popper: css(Styles.autoCompletePopper),
            paper: css(Styles.autoCompletePaper),
          }}
          onChange={(event, value) => handleChange({
            target: {
              name,
              value: value.map((item) => item.key),
            },
          })}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip
                label={option.value}
                {...getTagProps({ index })}
                className={css(Styles.autoCompleteChip)}
                deleteIcon={
                  <svg className={css(Styles.modalCloseIcon)} viewBox='0 0 36 36'>
                    <path d='M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z'></path>
                  </svg>
                }
              />
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder={selectedValues.length === 0 ? placeholder : ''}
              variant='standard'
              className={css(Styles.formControlDialog)}
              InputProps={{
                ...params.InputProps,
                disableUnderline: true,
                classes: {
                  root: css(Styles.textInputStylesDialog),
                  input: css(Styles.formInputStyle, Styles.textInput),
                },
              }}
            />
          )}
        />
      </FormControl>
    </Fragment>
  );
  const renderSingleSelect = (name, label, options, selectedValue, placeholder) => (
    <Fragment>
      <InputLabel className={css(Styles.fieldLabel)}>{label}</InputLabel>
      <FormControl className={css(Styles.formControl)} margin='normal' fullWidth>
        <Autocomplete
          options={options}
          value={options.find((option) => option.key === selectedValue) || null}
          getOptionLabel={(option) => option.value}
          classes={{
            inputRoot: css(Styles.autoCompleteInputRoot),
            popupIndicator: css(Styles.popupIndicator),
            popper: css(Styles.autoCompletePopper),
            paper: css(Styles.autoCompletePaper),
          }}
          onChange={(event, value) => handleChange({
            target: {
              name,
              value: value ? value.key : '',
            },
          })}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder={placeholder}
              variant='standard'
              className={css(Styles.formControlDialog)}
              InputProps={{
                ...params.InputProps,
                disableUnderline: true,
                classes: {
                  root: css(Styles.textInputStylesDialog),
                  input: css(Styles.formInputStyle, Styles.textInput),
                },
              }}
            />
          )}
        />
      </FormControl>
    </Fragment>
  );
  const normalizeGroupBy = (value) => {
    if (Array.isArray(value)) return value;
    if (value) return [value];
    return allowEmptyGroupBy ? [] : [defaultGroupBy];
  };
  const normalizeFilterBy = (value) => {
    if (Array.isArray(value)) {
      if (value.includes('NONE')) return [];
      return value.filter((item) => item && item !== 'NONE');
    }
    if (value && value !== 'NONE') return [value];
    return [];
  };
  const normalizeFilterByValue = (value, selectedFilterBy = normalizeFilterBy(initialFilterBy)) => {
    const initialValue = value && typeof value === 'object' && !Array.isArray(value)
      ? value
      : selectedFilterBy.reduce((acc, key) => ({ ...acc, [key]: typeof value === 'string' ? value : '' }), {});
    return selectedFilterBy.reduce((acc, key) => ({ ...acc, [key]: initialValue[key] || '' }), {});
  };
  const [dateStart, setDateStart] = useState(initialDateStart);
  const [dateEnd, setDateEnd] = useState(initialDateEnd);
  const [quickDateRange, setQuickDateRange] = useState(() => getMatchingQuickDateRange(initialDateStart, initialDateEnd));
  const [groupBy, setGroupBy] = useState(normalizeGroupBy(initialGroupBy));
  const [filterBy, setFilterBy] = useState(normalizeFilterBy(initialFilterBy));
  const [filterByValue, setFilterByValue] = useState(normalizeFilterByValue(initialFilterByValue));
  const [showSettingsDialog, setSettingsDialog] = useState(false);
  const maxFilterByValue = 5
  const [showMaxFilterByValueError, setMaxFilterByValueError] = useState({});
  const [showToast, setShowToast] = useState(false);
  const [severity, setSeverity] = useState('info');
  const [toastMsg, setToastMsg] = useState('');

  const handleChange = useCallback((event) => {
    const { name, value } = event.target;
    if (onClearDialogError) onClearDialogError();
    if (name === 'dateStart') {
      setDateStart(value);
      if (showQuickDateRangePicker) setQuickDateRange(getMatchingQuickDateRange(value, dateEnd));
    }
    if (name === 'dateEnd') {
      setDateEnd(value);
      if (showQuickDateRangePicker) setQuickDateRange(getMatchingQuickDateRange(dateStart, value));
    }
    if (name === 'groupBy') {
      setGroupBy(normalizeGroupBy(value));
    }
    if (name === 'filterBy') {
      const nextFilterBy = normalizeFilterBy(value);
      setFilterByValue((currentValue) => normalizeFilterByValue(currentValue, nextFilterBy))
      setMaxFilterByValueError((currentValue) => normalizeFilterByValue(currentValue, nextFilterBy))
      setFilterBy(nextFilterBy)
    }
    if (name.startsWith('filterByValue_')) {
      const filterKey = name.replace('filterByValue_', '');
      const newValue = adjustFilterByValue(value, filterKey)
      setFilterByValue((currentValue) => ({
        ...currentValue,
        [filterKey]: newValue,
      }));
    }
  }, [dateStart, dateEnd, showQuickDateRangePicker, onClearDialogError]);

  const handleQuickDateRangeChange = (event) => {
    const selectedRange = event.target.value;
    setQuickDateRange(selectedRange);
    if (onClearDialogError) onClearDialogError();
    const range = quickDateRanges.find((item) => item.key === selectedRange);
    if (range) {
      const dates = getQuickDateRange(range);
      setDateStart(dates.dateStart);
      setDateEnd(dates.dateEnd);
    }
  };

  const handleFilter = useCallback(async (fromDialog = false) => {
    const isGroupByValid = allowEmptyGroupBy || groupBy.length > 0;
    if (dateStart && dateEnd && isGroupByValid) {
      if (moment(dateEnd).isBefore(moment(dateStart))) {
        console.warn('End date must be greater than or equal to start date');
        onError()
        return;
      }
      const result = await onFilter({ dateStart, dateEnd, groupBy, filterBy, filterByValue, fromDialog });
      if (fromDialog && result === false) return;
      if (fromDialog) {
        setSettingsDialog(false)
      }
    }
  }, [dateStart, dateEnd, groupBy, onFilter, filterBy, filterByValue, allowEmptyGroupBy]);

  const handleCreateJob = useCallback(async () => {
    const isGroupByValid = allowEmptyGroupBy || groupBy.length > 0;
    if (!onCreateJob || !dateStart || !dateEnd || !isGroupByValid) return;
    if (moment(dateEnd).isBefore(moment(dateStart))) {
      console.warn('End date must be greater than or equal to start date');
      onError()
      return;
    }
    const result = await onCreateJob({ dateStart, dateEnd, groupBy, filterBy, filterByValue, fromDialog: true });
    if (result === false) return;
    setSettingsDialog(false)
  }, [allowEmptyGroupBy, dateEnd, dateStart, filterBy, filterByValue, groupBy, onCreateJob]);

  const adjustFilterByValue = (value, filterKey) => {
    if (value) {
      const values = value.split(',')
      if (values.length > maxFilterByValue) {
        setMaxFilterByValueError((currentValue) => ({
          ...currentValue,
          [filterKey]: true,
        }))
        return values.slice(0, maxFilterByValue).join(',')
      }
      setMaxFilterByValueError((currentValue) => ({
        ...currentValue,
        [filterKey]: false,
      }))
      return value
    }
    setMaxFilterByValueError((currentValue) => ({
      ...currentValue,
      [filterKey]: false,
    }))
    return value
  }

  const renderAppliedFilters = () => {
    const appliedFilterBy = filterBy.filter((key) => filterByValue[key] && filterByValue[key].trim() !== '');
    if (!groupBy.length && appliedFilterBy.length === 0) return ''
    return (
      <div className={css(Styles.appliedFiltersContainer)}>
        {groupBy.length > 0 && <div className={css(Styles.filterTile)}>Group By: {groupBy.join(', ')}</div>}
        {appliedFilterBy.map((key) => (
          <div className={css(Styles.filterTile)} key={key}>Filter By: {key} ({filterByValue[key]})</div>
        ))}
      </div>
    )
  }

  const onError = () => {
    setToastMsg(Helper.getString('dateErr'));
    setSeverity('error');
    setShowToast(true);
  }
  const getToast = () => {
    return (
      <Toast
        open={showToast}
        severity={severity}
        message={toastMsg}
        handleClose={() => setShowToast(false)}
      />
    )
  }


  const renderFilterDialog = () => {
    return (
      <Dialog
        open={showSettingsDialog === true}
        aria-labelledby={Helper.getString('setting')}
        fullWidth={AppHelper.fullWidthCondition()}
        fullScreen={AppHelper.fullWidthCondition()}
        TransitionComponent={window.innerWidth < 1024 ? Transition : Fade}
        maxWidth='lg'
        classes={{
          root: css(Styles.root),
          paper: css(Styles.paper),
        }}
      >
        <div className={css([Styles.modalHeader, AppStyles.modalHeader])}>
          <div className={css(Styles.modalTitle)}>{Helper.getString('setting')}</div>
          <button className={css(Styles.modalCloseButton)} onClick={() => { setSettingsDialog(false) }}>
            {UiHelper.renderImg({ key: 'dialogCloseIcon' })}
          </button>
        </div>
        <div className={css(Styles.modalContent)}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={groupByGridSize} lg={groupByGridSize}>
              {groupBySingleSelect
                ? renderSingleSelect('groupBy', 'Group by', groupByOptions, groupBy[0], 'Select group by')
                : renderMultiSelect('groupBy', 'Group by', groupByOptions, groupBy, 'Select group by')}
            </Grid>
            {filterByOptions && filterByOptions.length > 0 &&
              <Fragment>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  {renderMultiSelect('filterBy', 'Filter by', filterByOptions.filter((item) => item.key !== 'NONE'), filterBy, 'NONE')}
                </Grid>
                {filterBy.map((filterKey) => (
                  <Grid item xs={12} key={filterKey}>
                    <InputLabel className={css(Styles.fieldLabel)}>
                      {getFilterByHelperText(filterKey)}
                    </InputLabel>
                    <FormControl className={css(Styles.formControl)} margin='normal' fullWidth>
                      <TextField
                        name={`filterByValue_${filterKey}`}
                        value={filterByValue[filterKey] || ''}
                        onChange={handleChange}
                        variant={'standard'}
                        multiline={true}
                        rows={2}
                        className={css(Styles.formControlDialog)}
                        InputProps={{
                          disableUnderline: true,
                          classes: {
                            root: css(Styles.textInputStylesDialog),
                            input: css(Styles.textInput),
                          },
                        }}
                      />
                    </FormControl>
                    <InputLabel className={css(Styles.fieldErrorMessage)}>
                      {getFilterByErrorText(filterKey)}
                    </InputLabel>
                  </Grid>
                ))}
              </Fragment>
            }
            {dialogErrorMessage &&
              <Grid item xs={12}>
                <div className={css(Styles.dialogErrorText)}>{dialogErrorMessage}</div>
              </Grid>
            }
            <Grid item xs={12}>
              <div className={css(Styles.dialogButtonRow)}>
                {onCreateJob && dialogErrorMessage &&
                  <AppButton
                    inProcess={dialogJobInProcess}
                    buttonStyle={Styles.buttonOnDialog}
                    onClick={handleCreateJob}
                    buttonTextStyle={Styles.buttonTextStyle}
                    buttonText={createJobButtonLabel}
                  />
                }
                <AppButton
                  inProcess={dialogApplyInProcess !== undefined ? dialogApplyInProcess : inProcess}
                  buttonStyle={Styles.buttonOnDialog}
                  onClick={() => handleFilter(true)}
                  buttonTextStyle={Styles.buttonTextStyle}
                  buttonText={Helper.getString('apply')}
                />
              </div>
            </Grid>
          </Grid>
        </div>
      </Dialog>
    )
  }

  return (
    <Fragment>
      <div className={css(Styles.container)}>
        <form autoComplete='off' className={css(Styles.form)}>
          <div className={css(Styles.filterContainer)}>
            {showQuickDateRangePicker &&
              <div className={css(Styles.containerItems)}>
                <FormControl className={css(Styles.formControl)} margin='normal' fullWidth>
                  <Select
                    value={quickDateRange}
                    onChange={handleQuickDateRangeChange}
                    input={<Input disableUnderline classes={{ root: css(Styles.inputStyle) }} />}
                    inputProps={{ 'aria-label': 'Date range' }}
                  >
                    {quickDateRanges.map((range) => (
                      <MenuItem key={range.key} value={range.key}>{range.label}</MenuItem>
                    ))}
                    <MenuItem value='custom'>Custom</MenuItem>
                  </Select>
                </FormControl>
              </div>
            }
            <div className={css(Styles.containerItems)}>
              <FormControl className={css(Styles.formControl)} margin='normal' fullWidth>
                <TextField
                  name='dateStart'
                  placeholder='Start Date'
                  type='date'
                  onChange={handleChange}
                  value={dateStart}
                  inputProps={{ max: dateEnd }}
                  InputLabelProps={{
                    shrink: false, // Prevent label from shrinking to the top
                  }}
                  InputProps={{
                    classes: {
                      underline: css(Styles.noUnderline, Styles.inputStyle),
                    },
                    endAdornment: (
                      <img className={css(Styles.calenderIcon)} src={require('../assets/icons/calendar-blue.svg')} />
                    ),
                    startAdornment: null, // Optionally remove any adornments
                  }}

                />
              </FormControl>
            </div>
            <div className={css(Styles.containerItems)}>
              <FormControl className={css(Styles.formControl)} margin='normal' fullWidth>
                <TextField
                  name='dateEnd'
                  placeholder='End Date'
                  type='date'
                  onChange={handleChange}
                  value={dateEnd}
                  InputLabelProps={{
                    shrink: false, // Prevent label from shrinking to the top
                  }}
                  InputProps={{
                    classes: {
                      underline: css(Styles.noUnderline, Styles.inputStyle),
                    },
                    endAdornment: (
                      <img className={css(Styles.calenderIcon)} src={require('../assets/icons/calendar-blue.svg')} />
                    ),
                    startAdornment: null, // Optionally remove any adornments
                  }}
                />
              </FormControl>
            </div>
            {/* Filter */}
            <div>
              <AppButton
                inProcess={inProcess}
                progressIcon={Styles.progressIcon}
                buttonStyle={Styles.button}
                onClick={() => handleFilter(false)}
                buttonTextStyle={Styles.buttonTextStyle}
                buttonText={buttonLabel || 'Filter'}
              />
            </div>
            {/* Setting Icon */}
            <div className={css(Styles.settingIconContainer)}>
              <span className={css(Styles.settingsIcon) + ' material-icons-outlined'} onClick={()=> {
                // if (onClearDialogError) onClearDialogError()
                setSettingsDialog(true)
              }}>settings</span>
            </div>
          </div>
        </form>
      </div>

      {/* Applied Filter */}
      <div>
        {renderAppliedFilters()}
      </div>
      {/* Settings Dialog */}
      {renderFilterDialog()}
      {getToast()}
    </Fragment>
  );
};

const Styles = StyleSheet.create({
  fieldErrorMessage:{
    backgroundColor: '#FFFFFF',
    padding: '0 4px',
    borderRadius: 6,
    fontSize: 14,
    color: 'tomato',
    height: 15
  },
  dialogErrorText: {
    color: 'tomato',
    fontSize: 14,
    padding: '4px 0px 8px',
  },
  dialogButtonRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: 12,
    flexWrap: 'wrap'
  },
  filterTile: {
    backgroundColor: '#FFFFFF',
    padding: 10,
    borderRadius: 6,
    fontSize: 14
  },
  appliedFiltersContainer: {
    display: 'flex',
    gap: 15,
    marginBottom: 15
  },
  disabledInput:{
    background: 'rgb(217,217,217)'
  },
  formControlDialog:{
    borderRadius: AppTheme.borderRadius,
    // border: '1px solid #E5E5E5',
    background: '#FFFFFF',
    overflow: 'hidden'
  },
  autoCompleteInputRoot: {
    minHeight: 48,
    boxSizing: 'border-box',
    // flexWrap: 'nowrap !important',
    overflowX: 'auto',
    overflowY: 'hidden',
    alignItems: 'center',
    padding: '11px 20px !important',
    '::-webkit-scrollbar': {
      display: 'none'
    }
  },
  autoCompleteTag: {
    backgroundColor: '#e0e0e0',
    color: '#222222',
    fontSize: 13,
    borderRadius: 8,
    height: 26
  },
  autoCompleteChip: {
    margin: '2px 4px 2px 4px !important',
    backgroundColor: '#d2d2d2d9',
    color: '#222222',
    fontSize: 13,
    borderRadius: 8,
    height: 26
  },
  modalCloseIcon: {
    width: 12,
    height: 12,
    padding: 1,
    borderRadius: 6
  },
  textInputStylesDialog:{
    padding: '6px 12px',
    flex: 1,
    textAlign: 'left',
    color: '#222222',
    fontSize: 16,
    backgroundColor: 'rgb(247, 247, 249)',
  },
  textInput: {
    padding: '4px 0px'
  },
  formInputStyle: {
    '::-webkit-scrollbar': {
      display: 'none'
    }
  },
  menuProps: {
    zIndex: 130000,
    marginTop: 5
  },
  autoCompletePopper: {
    zIndex: '130001 !important',
  },
  autoCompletePaper: {
    zIndex: '130001 !important',
    marginTop: 5,
    borderRadius: AppTheme.borderRadius,
  },
  fieldLabel: {
    fontSize: 14,
    color: 'grey',
    margin: '0px 0px 4px',
  },
  popupIndicator: {
    marginRight: 5,
  },
  modalHeader: {
    padding: 20,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 14,
    marginBottom: 10
  },
  modalTitle: {
    color: '#222222',
    fontSize: 28,
    maxWidth: 180,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontWeight: 600
  },
  modalContent: {
    width: 700,
    padding: '0px 32px 20px !important',
    '@media (max-width: 1024px)': {
      width: 'auto',
    }
  },
  hideInWeb:{
    display:'none',
    '@media (max-width: 1024px)': {
      display:'flex',
    }
  },
  showInWeb:{
    display:'block',
    '@media (max-width: 1024px)': {
      display:'none',
    }
  },
  modalCloseButton: {
    position: 'absolute',
    top: 23,
    right: 30,
    padding: 0,
    border: 'none',
    backgroundColor: 'transparent',
    display: 'flex',
    outline: 'none',
    cursor: 'pointer',
  },
  root: {
    zIndex: 13000,
  },
  paper: {
    borderRadius: AppTheme.borderRadius,
    '@media (max-width: 1024px)': {
      maxHeight: 'calc(100% - 140px) !important',
      borderRadius: '20px 20px 0 0',
      bottom: '0 !important',
      position: 'fixed',
      height: 'auto !important'
    }
  },
  settingIconContainer: {
    width: 44,
    height: 44,
    backgroundColor: 'rgb(255, 255, 255)',
    borderRadius: '50%',
    display: 'flex',
    cursor: 'pointer',
    alignItems: 'center',
    justifyContent: 'center'
  },
  settingsIcon: {
    fontSize: 20,
    color: AppTheme.primaryColor
  },
  calenderIcon: {
    position: 'absolute',
    right: '0',
    background: '#fff',
    pointerEvents:'none'
  },
  filterContainer:{
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    gap: 12,
    '@media (max-width: 1024px)': {
      flexWrap: 'wrap',
      justifyContent: 'flex-end',
      gap: '8px !important'
    }
  },
  containerItems:{
    flex: 1,
    background: '#fff',
    padding: '0 13px',
    borderRadius: '8px',
    height: '45px'
  },
  formControl:{
    marginTop: 8
  },
  inputStyle:{
    fontSize: 16,
    color: '#575757'
  },
  noUnderline: {
    '::before': {
      borderBottom: 'none',
    },
    '::hover::before': {
      borderBottom: 'none',
    },
    '::after': {
      borderBottom: 'none',
    },
  },
  textInputStyles: {
    // padding: '11px 20px',
    flex: 1,
    textAlign: 'left',
    color: '#222222',
    fontSize: 14,
    margin: 0,
    ':focus': {
      backgroundColor: '#ffffff'
    }
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: 8,
    marginTop: 16,
    maxWidth: AppTheme.viewPort,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    maxWidth: AppTheme.viewPort,
    padding: 0,
    width: '100%',
    borderRadius: 8,
    '@media (max-width: 320px)': {
      maxWidth: 300,
      paddingBottom: 15,
    },
  },
  margin: {
    margin: 0,
    textAlign: 'left'
  },
  button: {
    background: '#ffffff',
    color: AppTheme.primaryColor,
    backgroundColor: AppTheme.secondaryBg,
    display: 'inline-flex'
  },
  buttonOnDialog:{
    color: '#ffffff'
  },
  buttonTextStyle: {
    fontWeight: 550
  },
  progressIcon:{
    color: '#0008be'
  }
});

export default AdPopFilterBar;



// WEBPACK FOOTER //
// ./src/components/AdPopFilterBar.js